import { render } from "./inputfuel.vue?vue&type=template&id=566ff3ce"
import script from "./inputfuel.vue?vue&type=script&lang=js"
export * from "./inputfuel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT_REPOS\\pilot-tools\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__